import {connect} from '@store/@common';

import {KpiProgressBanner} from './KpiProgressBanner';
import {kpiRequestsByUser} from '@store/kpi/KpiObservation.selectors';
import KpiObservationActions from '@store/kpi/KpiObservationActions';
import {authUser} from '@store/auth';
import {kpisById} from '@store/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';

const mapStateToProps = {
  kpiRequestsByUser,
  authUser,
  kpisById,
};

const mapDispatchToProps = {
  fetchObservations: KpiObservationActions.search,
  fetchRequests: KpiObservationActions.getReminders,
  fetchKpis: KpiGoalActions.fetchGoalKpiTree,
  submit: KpiObservationActions.create,
};

export default connect(KpiProgressBanner, mapStateToProps, mapDispatchToProps);
